import * as React from 'react';
import { EveryTravelService, GdsAggregationServiceGroup } from '../../../Checkout/types';
import CheckoutAdditionalService from '../..';
import { useTheme } from '../../../theme';
import { useRouteMatch } from 'react-router';
import { useHistory } from '@shared/routing';
import { useTranslation } from 'react-i18next';

interface Props {
	service: GdsAggregationServiceGroup;
}

const EveryTravel: React.FC<Props> = ({ service }) => {
	const everyTravel = service.services[0] as EveryTravelService;

	const theme = useTheme('CheckoutAdditionalService').EveryTravel;

	const { t } = useTranslation('Checkout');

	const { url } = useRouteMatch();
	const history = useHistory();

	const onEditHandler = () => {
		history.push(`${url}/explore/${everyTravel.excursionId}`);
	};

	return (
		<CheckoutAdditionalService
			header={everyTravel.title}
			priceTotal={everyTravel.price}
			mode={'aggregator'}
			description={null}
			isSelected={true}
			coverBackgroundUrl={everyTravel.imageUrl}
			coverClassName={theme.cover}
			addClick={() => {}}
			buttons={[
				{
					text: t(service.canAddService ? 'Change' : 'Details'),
					action: onEditHandler
				}
			]}
		>
			{everyTravel.date} {everyTravel.time}
		</CheckoutAdditionalService>
	);
};

export default EveryTravel;
